import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import {
  RatingsAndReviewsDefaultProps,
  StoreRatingsAndReviewsPropTypes
} from './RatingsAndReviewsPropTypes';
import { RatingsAndReviewsPlaceholder } from './RatingsAndReviewsPlaceholder';
import { dataModel } from './ReviewDataModel';

const placeholder = (
  <RatingsAndReviewsPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return (import('./StoreRatingsAndReviewsDesktop')).StoreRatingsAndReviewsDesktop;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "store-ratings-and-reviews-desktop" */
      './StoreRatingsAndReviewsDesktop');
  },
  placeholder,
  name: 'StoreRatingsAndReviewsDesktop'
});

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'store-section-rr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const StoreRatingsAndReviewsDesktopImporter = withErrorBoundary(DynamicComponent);

StoreRatingsAndReviewsDesktopImporter.displayName = 'StoreRatingsAndReviewsDesktopImporter';
StoreRatingsAndReviewsDesktopImporter.propTypes = StoreRatingsAndReviewsPropTypes;
StoreRatingsAndReviewsDesktopImporter.defaultProps = RatingsAndReviewsDefaultProps;
StoreRatingsAndReviewsDesktopImporter.dataModel = dataModel;
